import React, { useEffect, useRef, useState } from "react";
import { CalendarDays } from "lucide-react";
import { Input } from "./ui/input";

// Tampilan DD/MM/YYYY untuk pengguna; nilai (value/onChange) tetap ISO YYYY-MM-DD untuk backend.
export const isoToDisplay = (iso) => {
  if (!iso || !/^\d{4}-\d{2}-\d{2}/.test(iso)) return iso || "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

// Display DD/MM/YYYY HH:mm untuk ISO datetime (zona waktu mengikuti browser, sama seperti sebelumnya).
export const isoToDisplayDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

const displayToIso = (txt) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(txt);
  if (!m) return null;
  const [, d, mo, y] = m;
  const dt = new Date(Number(y), Number(mo) - 1, Number(d));
  if (dt.getFullYear() !== Number(y) || dt.getMonth() !== Number(mo) - 1 || dt.getDate() !== Number(d)) return null;
  return `${y}-${mo}-${d}`;
};

const mask = (raw) => {
  const digits = raw.replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const DateInput = ({ value, onChange, testId, className = "" }) => {
  const [text, setText] = useState(isoToDisplay(value));
  const [invalid, setInvalid] = useState(false);
  const nativeRef = useRef(null);

  useEffect(() => { setText(isoToDisplay(value)); setInvalid(false); }, [value]);

  const handleText = (e) => {
    const t = mask(e.target.value);
    setText(t);
    if (t === "") { setInvalid(false); onChange(""); return; }
    const iso = displayToIso(t);
    if (iso) { setInvalid(false); onChange(iso); } else setInvalid(t.length === 10);
  };

  const openPicker = () => {
    const el = nativeRef.current;
    if (!el) return;
    if (el.showPicker) el.showPicker(); else el.click();
  };

  return (
    <div className="relative">
      <Input inputMode="numeric" placeholder="DD/MM/YYYY" value={text} onChange={handleText} onBlur={() => setInvalid(text !== "" && !displayToIso(text))}
        data-testid={testId} className={`min-h-[44px] rounded-xl pr-12 font-mono ${invalid ? "border-red-400" : ""} ${className}`} aria-invalid={invalid} />
      <button type="button" onClick={openPicker} className="absolute right-1 top-1/2 -translate-y-1/2 h-10 w-10 rounded-lg flex items-center justify-center text-slate-500 hover:bg-slate-100" data-testid={testId ? `${testId}-picker` : undefined} aria-label="Buka kalender">
        <CalendarDays className="h-4 w-4" />
      </button>
      <input ref={nativeRef} type="date" tabIndex={-1} value={value || ""} onChange={(e) => onChange(e.target.value)} className="absolute opacity-0 pointer-events-none w-0 h-0" data-testid={testId ? `${testId}-native` : undefined} />
      {invalid && <p className="text-xs text-red-500 mt-1" data-testid={testId ? `${testId}-error` : undefined}>Format tanggal harus DD/MM/YYYY</p>}
    </div>
  );
};

export default DateInput;
